var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "60%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red", loading: _vm.buttonDelete },
                  on: { click: _vm.onPressDelete },
                },
                [_c("v-icon", [_vm._v("mdi-delete")])],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "grey" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-autocomplete", {
                staticClass: "ml-5 mr-5 mb-0",
                attrs: {
                  dense: "",
                  items: _vm.groups,
                  outlined: "",
                  "item-text": (item) => item.name,
                  "item-value": "name",
                  "return-object": "",
                  "small-chips": "",
                  "deletable-chips": "",
                },
                model: {
                  value: _vm.selectedGroup,
                  callback: function ($$v) {
                    _vm.selectedGroup = $$v
                  },
                  expression: "selectedGroup",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-card-text", { staticClass: "grey--text" }, [
                _vm._v(_vm._s(_vm.keyId)),
              ]),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c(
                "v-card",
                {
                  staticClass: "ml-5 mr-5 mb-8 white--text",
                  attrs: {
                    color: _vm.getGroupColor(),
                    width: "100%",
                    elevation: "0",
                    outlined: "",
                  },
                },
                [
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" " + _vm._s(this.keyName) + " "),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-textarea", {
                staticClass: "ml-5 mr-5 mt-0",
                attrs: { label: "Value", outlined: "" },
                model: {
                  value: _vm.valueName,
                  callback: function ($$v) {
                    _vm.valueName = $$v
                  },
                  expression: "valueName",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonApply, color: "primary" },
                  on: { click: _vm.onPressApply },
                },
                [_vm._v("APPLY ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }